import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Guay_Jub_Yuan from '../../assets/img/menu/Guay_Jub_Yuan.png';
import Boiled_Pork_Rice from '../../assets/img/menu/Boiled_Pork_Rice.png';
import Pork_Congee from '../../assets/img/menu/Pork_Congee.png';
import Pan_fried_Eggs from '../../assets/img/menu/Pan_fried_Eggs.png';
import Chicken_Khao_Soi from '../../assets/img/menu/Chicken_Khao_Soi.png';
import Boiled_Eggs from '../../assets/img/menu/Boiled_Eggs.png';
import Mango_Sticky_Rice from '../../assets/img/menu/Mango_Sticky_Rice.png';
import Kaya_Sticky_Rice from '../../assets/img/menu/Kaya_Sticky_Rice.png';
import Toast_with_Kaya from '../../assets/img/menu/Toast.png';
import Patongko_with_Kaya from '../../assets/img/menu/Patongko.png';
import Americano from '../../assets/img/menu/Americano.png';
import Cappuccino from '../../assets/img/menu/Cappuccino.png';
import Latte from '../../assets/img/menu/Latte.png';
import Mocha from '../../assets/img/menu/Mocha.png';
import Thai_Milk_Tea from '../../assets/img/menu/Thai_Milk_Tea.png';
import Chocolate_Signature from '../../assets/img/menu/Chocolate_Signature.png';
import Coke from '../../assets/img/menu/Coke.png';
import Mineral_Water from '../../assets/img/menu/Mineral_Water.png';
import Kanom_Krok from '../../assets/img/menu/Kanom_Krok.png';
import './MenuPage.css';

const MenuPage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialType = queryParams.get('type') || 'all';
    
    const [selectedType, setSelectedType] = useState(initialType);
    const [language, setLanguage] = useState('th');

    const getLanguageFromLocalStorage = useCallback(() => {
        const lang = localStorage.getItem('lang');
        if (lang) {
            setLanguage(lang);
        } else {
            localStorage.setItem('lang', 'th');
        }
    }, []);

    useEffect(() => {
        setSelectedType(initialType);
        getLanguageFromLocalStorage();
    }, [initialType, getLanguageFromLocalStorage]);

    const menuTitle = useMemo(() => {
        const titles = {
            th: 'เมนูอาหาร',
            en: 'Menu',
            cn: '菜单'
        };
        return titles[language];
    }, [language]);

    const menuData = useMemo(() => [
        {
            id: 1,
            image: Guay_Jub_Yuan,
            title_th: 'ก๋วยจั๊บญวน',
            title_en: 'Guay Jub Yuan',
            title_cn: '越南粿汁 (Yuènán guǒ zhī)',
            description_th: 'เส้นก๋วยจั๊บเวียดนาม ลูกชิ้นหมู อกไก่ต้ม น้ำซุปสูตรลับ',
            description_en: 'Vietnamese-style rolled noodles with pork balls, boiled chicken breast, secret recipe soup',
            description_cn: '越南风味卷粉配猪肉丸、鸡胸肉和秘制汤',
            price: '60',
            type: '1'
        },
        {
            id: 2,
            image: Boiled_Pork_Rice,
            title_th: 'ข้าวต้มหมู',
            title_en: 'Boiled Pork Rice',
            title_cn: '猪肉粥',
            description_th: 'ข้าวหอมมะลิ หมูสับผัด น้ำซุปสูตรลับ',
            description_en: 'Jasmine rice, minced pork stir-fry, secret recipe soup',
            description_cn: '茉莉香米饭，炒猪肉末，秘制汤',
            price: '60',
            type: '1'
        },
        {
            id: 3,
            image: Pork_Congee,
            title_th: 'โจ๊กหมู ไข่ลวก',
            title_en: 'Pork Congee',
            title_cn: '猪肉粥',
            description_th: '',
            description_en: 'Boiled jasmine rice, pork balls, served with boiled egg, young ginger, chopped spring onion',
            description_cn: '茉莉香米饭，猪肉丸，配水煮蛋，嫩姜，葱花',
            price: '60',
            type: '1'
        },
        {
            id: 4,
            image: Pan_fried_Eggs,
            title_th: 'ไข่กระทะ',
            title_en: 'Pan-fried Eggs',
            title_cn: '煎蛋',
            description_th: 'ไข่ 2 ฟอง ไก่ยอ กุญเชียง หมูสับผัด',
            description_en: '2 fried eggs, pork loin, minced pork stir-fry',
            description_cn: '两只煎蛋，猪里脊肉，炒猪肉末',
            price: '60',
            type: '1'
        },
        {
            id: 5,
            image: Chicken_Khao_Soi,
            title_th: 'ข้าวซอยไก่',
            title_en: 'Chicken Khao Soi',
            title_cn: '鸡肉椰浆米线 (jīròu yējiāng mǐxiàn)',
            description_th: 'เส้นข้าวซอย สโพกไก่ น้ำซุปข้าวซอยเข้มข้น',
            description_en: 'Noodle Khao Soi with chicken curry',
            description_cn: '米粉搭配鸡肉丸和浓厚的米粉汤',
            price: '60',
            type: '1'
        },
        {
            id: 6,
            image: Boiled_Eggs,
            title_th: 'ไข่ลวก 2 ฟอง',
            title_en: 'Boiled Eggs, 2 ea',
            title_cn: '两个煮鸡蛋',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: '30',
            type: '1'
        },
        {
            id: 7,
            image: Mango_Sticky_Rice,
            title_th: 'ข้าวมันมะม่วง',
            title_en: 'Mango Sticky Rice',
            title_cn: '芒果糯米饭',
            description_th: '',
            description_en: 'Ripe mango with coconut-flavored sticky rice',
            description_cn: '椰香糯米糍配熟芒果',
            price: '100',
            type: '2'
        },
        {
            id: 8,
            image: Kaya_Sticky_Rice,
            title_th: 'ข้าวมันสังขยา',
            title_en: 'Kaya Sticky Rice',
            title_cn: '香甜椰香糯米',
            description_th: '',
            description_en: 'Sangkhaya Steamed Custard with Sticky Rice',
            description_cn: '椰香糯米饭配椰子蒸蛋羹',
            price: '60',
            type: '2'
        },
        {
            id: 9,
            image: Toast_with_Kaya,
            title_th: 'ปังปิ้ง สังขยา|นมข้น',
            title_en: 'Toast with Kaya | C. Milk',
            title_cn: '烤面包 香甜椰香糯米|炼乳',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: '60',
            type: '2'
        },
        {
            id: 10,
            image: Patongko_with_Kaya,
            title_th: 'ปาท่องโก๋ สังขยา|นมข้น',
            title_en: 'Patongko with Kaya | C. Milk',
            title_cn: '油条 香甜椰香糯米|炼乳',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: '60',
            type: '2'
        },
        {
            id: 11,
            image: Americano,
            title_th: 'อเมริกาโน',
            title_en: 'Americano',
            title_cn: '美式咖啡',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H50|C60',
            type: '3'
        },
        {
            id: 12,
            image: Cappuccino,
            title_th: 'คาปูชิโน',
            title_en: 'Cappuccino',
            title_cn: '卡布奇诺',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H60|C70',
            type: '3'
        },
        {
            id: 13,
            image: Latte,
            title_th: 'ลาเต้',
            title_en: 'Latte',
            title_cn: '拿铁',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H50|C60',
            type: '3'
        },
        {
            id: 14,
            image: Mocha,
            title_th: 'มอคค่า',
            title_en: 'Mocha',
            title_cn: '摩卡',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H50|C60',
            type: '3'
        },
        {
            id: 15,
            image: Thai_Milk_Tea,
            title_th: 'ชาไทย',
            title_en: 'Thai Milk Tea',
            title_cn: '奶茶',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H60|C70',
            type: '3'
        },
        {
            id: 16,
            image: Chocolate_Signature,
            title_th: 'ช็อกโกแลต ซิกเนเจอร์ ',
            title_en: 'Chocolate Signature',
            title_cn: '巧克力招牌饮品',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: 'H60|C70',
            type: '3'
        },
        {
            id: 17,
            image: Coke,
            title_th: 'โค้ก, สไปรท์',
            title_en: 'Coke, Sprite',
            title_cn: '可乐, 雪碧',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: '25',
            type: '3'
        },
        {
            id: 18,
            image: Mineral_Water,
            title_th: 'น้ำเปล่า 600ml',
            title_en: 'Mineral Water 600ml',
            title_cn: '矿泉水 600毫升',
            description_th: '',
            description_en: '',
            description_cn: '',
            price: '20',
            type: '3'
        },
        {
            id: 19,
            image: Kanom_Krok,
            title_th: 'ขนมคลก',
            title_en: 'Kanom Krok',
            title_cn: '椰浆糯米糕',
            description_th: '',
            description_en: 'Thai Coconut Pancakes',
            description_cn: '泰式椰浆糯米糕',
            price: '60',
            type: '2'
        }
    ], []);

    const filterMenu = useCallback((type) => {
        setSelectedType(type);
    }, []);

    const filteredMenuItems = useMemo(() => {
        return menuData.filter(menu => selectedType === 'all' || menu.type === selectedType);
    }, [selectedType, menuData]);

    const menuItems = useMemo(() => {
        return filteredMenuItems.map(menu => (
            <div key={menu.id} className="col-12 col-md-6 col-lg-4 mt-3">
                <div className="card h-100 d-flex flex-row align-items-center">
                    <img src={menu.image} className="card-img-left" alt={menu.title} style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                    <div className="card-body">
                        <h5 className="card-title">{menu[`title_${language}`]}</h5>
                        <p className="card-text">{menu[`description_${language}`]}<br/>{menu.price}.-</p>
                    </div>
                </div>
            </div>
        ));
    }, [filteredMenuItems, language]);

    return (
        <>
            <Header />
            <main>
                <div className='container'>
                    <div className='row'><div className="col-12"><hr /></div></div>
                    <div className='row '>
                        <div className="col-12 d-flex justify-content-center">
                            <h2>{menuTitle}</h2>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className="col-12 d-flex justify-content-center">

                            <button onClick={() => filterMenu('1')} className="btn btn-outline-secondary btn-sm" type="button">{language === 'th' ? 'จานหลัก' : language === 'en' ? 'Main Dishes' : '主菜'}</button>
                            <button onClick={() => filterMenu('2')} className="btn btn-outline-secondary btn-sm ms-2" type="button">{language === 'th' ? 'ของหวาน' : language === 'en' ? 'Desserts' : '甜点'}</button>
                            <button onClick={() => filterMenu('3')} className="btn btn-outline-secondary btn-sm ms-2" type="button">{language === 'th' ? 'เครื่องดื่ม' : language === 'en' ? 'Drinks' : '饮料'}</button>
                            <button onClick={() => filterMenu('all')} className="btn btn-outline-secondary btn-sm ms-2" type="button">{language === 'th' ? 'ทั้งหมด' : language === 'en' ? 'All Dishes' : '全部'}</button>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        {menuItems}
                    </div>
                    <div className='row '><div className="col-12"><hr /></div></div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default MenuPage;